export default __webpack_public_path__ + "static/media/ChromatographyImg.5e106e8c.jpg";